// extracted by mini-css-extract-plugin
export default {"active":"active_active__Qe5d0"};